import * as React from 'react';
import { CircularProgress, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import PocketBase from 'pocketbase';

import NavigateBackScaffold from 'app/components/scaffold/NavigateBackScaffold';
import { useState } from 'react';
import { pocketBase } from 'config';
import { useLocation, useHistory } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
    const { handleSubmit, register, errors, setError } = useForm({
        defaultValues: { email: '', password: '', newPassword: '' }
    });

    const [linkSentSuccessfully, setLinkSentSuccessfully] = useState(false);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const location = useLocation()
    const history = useHistory()

    React.useEffect(() => {
        const savedEmail = localStorage.getItem("email");
        if (savedEmail) {
            setEmail(savedEmail);
        }
    }, []);

    // Änderungen direkt in localStorage speichern
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value);
        localStorage.setItem("email", value);
    };

    const getToken = React.useCallback(() => {
        const pArr = (location.pathname ?? '').split('/')
        if (pArr.length > 0) {
            return pArr[pArr.length - 1] !== 'reset_password' ? pArr[pArr.length - 1] : ''
        }
        return ''
    }, [location.pathname])

    const onSubmit = handleSubmit(async ({ email }) => {
        setLoading(true);

        // console.log('email', email)

        const pb = new PocketBase(pocketBase.url);

        await pb.collection('users').requestPasswordReset(email.trim().toLowerCase()).catch((error) => {
            console.log(error)
            setError("email", { type: "custom", message: "Fehler beim Setzen des Passwortes." })
            setLoading(false);
            return
        });

        localStorage.setItem("email", email.trim().toLowerCase());

        await setTimeout(() => {
            setLinkSentSuccessfully(true);
            setLoading(false);
        }, 100);
    });

    const onSubmitNew = handleSubmit(async ({ password, newPassword }) => {

        // console.log('onSubmitNew', { password, newPassword })

        if (password !== newPassword) {
            setError("newPassword", { type: "custom", message: "Die Passwörter müssen übereinstimmen." })
            return
        }

        setLoading(true);

        const pb = new PocketBase(pocketBase.url);

        try {
            await pb.collection('users').confirmPasswordReset(
                getToken(),
                password,
                newPassword,
            ).catch((error) => {
                console.log(error)
                setError("newPassword", { type: "custom", message: "Fehler beim Setzen des Passwortes." })
                setLoading(false);
                return
            });
        } catch (err: any) {
            console.log(err.response);
            setError("newPassword", { type: "custom", message: "Fehler beim Setzen des Passwortes." })
            setLoading(false);
            return
        }
        await setTimeout(() => {
            setLinkSentSuccessfully(true);
            setLoading(false);
            history.push("/")
        }, 100);
    });

    const linkSentView = (
        <>
            <DialogTitle>Ein Link zum Zurücksetzen des Passworts wurde an Deine E-Mail Addresse gesendet.</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Die Zustellung kann bis zu 5 Minuten in Anspruch nehmen. Falls Du keine E-Mail erhalten hast, sehe bitte in Deinem Spam / Junk Ordner
                    nach oder versuche es erneut.
                </DialogContentText>
                <Button type="submit" fullWidth variant="contained" color="primary" onClick={() => setLinkSentSuccessfully(false)}>
                    Erneut anfordern
                </Button>
            </DialogContent>
        </>
    );

    const passwordResetForm = (
        <form style={{ flexGrow: 1 }} noValidate onSubmit={onSubmit}>
            <DialogTitle> Setze Dein Passwort zurück</DialogTitle>
            <TextField
                label="E-Mail Adresse"
                fullWidth
                variant="outlined"
                margin="normal"
                autoComplete="email"
                name="email"
                type='email'
                error={!!errors?.email}
                value={email}
                inputRef={register({ required: true })}
                onChange={handleChange}
            />
            {errors.email?.types && <p>{errors.email.types?.message ?? ''}</p>}
            <Button disabled={loading} type="submit" fullWidth variant="contained" color="primary">
                {
                    loading
                        ? <CircularProgress size={24} />
                        : '  Passwort zurücksetzen'
                }
            </Button>
        </form>
    );
    const passwordNewForm = (
        <form style={{ flexGrow: 1 }} onSubmit={onSubmitNew}>
            <DialogTitle>Passwort setzen
                {
                    localStorage.getItem("email") ?
                        ` für ${localStorage.getItem("email") ?? ''}`
                        : null
                }
            </DialogTitle>
            <TextField
                label="Neues Passwort"
                type='password'
                required
                fullWidth
                variant="outlined"
                margin="normal"
                autoComplete="password"
                name="password"
                error={!!errors.password}
                inputRef={register({ required: true })}
            />
            <TextField
                label="Passwort wiederholen"
                type='password'
                required
                fullWidth
                variant="outlined"
                margin="normal"
                name="newPassword"
                error={!!errors.newPassword}
                inputRef={register({ required: true })}
            />
            {errors.newPassword?.types && <p>{errors.newPassword.types?.message ?? ''}</p>}
            <Button disabled={loading} type="submit" fullWidth variant="contained" color="primary">
                {
                    loading
                        ? <CircularProgress size={24} />
                        : '  Passwort setzen'
                }
            </Button>
        </form>
    );

    // React.useEffect(() => {
    //     setError("newPassword", {
    //         type: "manual",
    //         message: "Die Passwörter müssen übereinstimmen.",
    //     })
    // }, [setError])

    // console.log('errors', errors)

    return (
        <NavigateBackScaffold actions={<></>} title={'Passwort zurücksetzen'}>
            <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '50vh' }}>
                {
                    getToken() === ''
                        ? <Grid item md={6}>
                            {
                                linkSentSuccessfully
                                    ? linkSentView
                                    : passwordResetForm
                            }
                        </Grid>
                        : <Grid item md={6}>
                            {passwordNewForm}
                        </Grid>
                }

            </Grid>
        </NavigateBackScaffold>
    );
};

export default ResetPasswordPage;
